define('mailsListLabelsFilterView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'jquery',
  'backbone',
  'mailsMailHeaderLabelsAddView',
  'template!mailsListLabelsFilterView',
  'windows',
  'settings'
], function (
  App,
  Module,
  Marionette,
  _,
  $,
  Backbone,
  LabelsAddView,
  Tpl,
  Windows,
  Settings
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'labels-filter-view',

    regions: {
      selectedLabelsRegion: '.selected-labels-region'
    },

    ui: {
      addLabelBtn: '.add-label',
      clearFilter: '.clear-filter',
      selectedLabelsContainer: '.selected-labels-container'
    },

    events: {
      'click @ui.addLabelBtn': 'onAddLabelClick',
      'click @ui.clearFilter': 'onClearFilter'
    },

    initialize: function(options) {
      this.parentView = options.parentView;
      this.allLabels = [];
      this.selectedLabels = [];
      this.selectedLabelsCollection = new Backbone.Collection();
      
      // Try to fetch labels if mailSecId is already available
      this.tryFetchLabels();
      
      // Listen for mailSecId changes in the parent view
      this.listenTo(this.parentView.mailsView, 'change:mailSecId', this.onMailSecIdChange);
    },
    
    // Get cookie key specific to the current email address
    getCookieKey: function() {
      var mailSecId = this.parentView && this.parentView.mailsView ? this.parentView.mailsView.mailSecId : '';
      return 'mailbox_selected_labels_' + mailSecId;
    },
    
    // Load labels from cookie
    loadLabelsFromCookie: function() {
      // Cookie key for storing selected labels
      var cookieKey = this.getCookieKey();
      
      // Load selected labels from cookie if available
      var savedLabels = Settings.get(cookieKey, true);
      if (savedLabels) {
        try {
          this.selectedLabels = JSON.parse(savedLabels);
          // Store that we have labels from cookie that need to be applied
          this.hasLabelsFromCookie = true;
        } catch (e) {
          console.error('Error parsing saved labels from cookie:', e);
          this.selectedLabels = [];
        }
      } else {
        // Clear selected labels if no cookie found for this email address
        this.selectedLabels = [];
        this.hasLabelsFromCookie = false;
      }
    },
    
    onMailSecIdChange: function() {
      // When email address changes, load labels from cookie for the new email address
      this.loadLabelsFromCookie();
      this.renderSelectedLabels();
      
      // Then fetch labels for the new email address
      this.tryFetchLabels();
    },
    
    tryFetchLabels: function() {
      // Check if mailSecId is available
      if (this.parentView && this.parentView.mailsView && this.parentView.mailsView.mailSecId) {
        // Load labels from cookie for the current email address
        this.loadLabelsFromCookie();
        
        // Fetch labels from server
        this.fetchLabels();
      }
    },

    fetchLabels: function() {
      var self = this;
      
      // Get the mail sec ID from the parent view's mail view
      var mailSecId = this.parentView.mailsView.mailSecId;
      
      if (!mailSecId) {
        return;
      }
      
      // Fetch all available labels from the server
      $.ajax({
        url: App.request('mails:get-folders-url', mailSecId, { getLabels: true, folder: 'all' }),
        method: 'GET',
        success: function(response) {
          if (response) {
            self.allLabels = response.filter(function(label) {
              return label.name && !label.name.startsWith('CATEGORY_');
            });
            
            // If there are selected labels, re-render them with the updated label data
            if (self.selectedLabels.length > 0) {
              self.renderSelectedLabels();
              
              // If we have labels from cookie that need to be applied, trigger the filter
              if (self.hasLabelsFromCookie) {
                self.trigger('filter:labels', self.selectedLabels);
                self.hasLabelsFromCookie = false; // Reset the flag so we don't apply again
              }
            }
          }
        },
        error: function() {
          console.error('Failed to fetch labels');
        }
      });
    },
    
    renderSelectedLabels: function() {
      var self = this;
      this.ui.selectedLabelsContainer.empty();
      _.each(this.selectedLabels, function(labelId) {
        var labelData = _.find(self.allLabels, function(l) {
          return l.id === labelId || l.name === labelId;
        });
        
        if (labelData) {
          var $label = $('<div class="selected-label"></div>')
            .css({
              'background-color': labelData.backgroundColor || '#f1f1f1',
              'color': labelData.textColor || '#333'
            });
          
          var $value = $('<div class="label-value"></div>')
            .text(labelData.name);
          
          // Create SVG for delete button (X icon)
          var svgHtml = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">' +
                        '<path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 ' +
                        '86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 ' +
                        '12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 ' +
                        '45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path></svg>';
          
          var $deleteButton = $('<div class="label-delete-button"></div>')
            .html(svgHtml);
          
          // Set the SVG fill color to match the text color
          $deleteButton.find('svg path').css('fill', labelData.textColor || '#333');
          
          $deleteButton.on('click', function(e) {
            e.stopPropagation();
            self.removeLabel(labelId);
          });
          
          $label.append($deleteButton).append($value);
          self.ui.selectedLabelsContainer.append($label);
        }
      });
      
      // Show or hide the container based on whether there are selected labels
      if (this.selectedLabels.length > 0) {
        this.ui.selectedLabelsContainer.show();
      } else {
        this.ui.selectedLabelsContainer.hide();
      }
    },
    
    // Save selected labels to cookie
    saveSelectedLabels: function() {
      // Get cookie key specific to the current email address
      var cookieKey = this.getCookieKey();
      
      // Save to cookie
      Settings.set(cookieKey, JSON.stringify(this.selectedLabels), true);
    },
    
    removeLabel: function(labelId) {
      this.selectedLabels = _.without(this.selectedLabels, labelId);
      this.renderSelectedLabels();
      
      // Save to cookie
      this.saveSelectedLabels();
      
      if (this.selectedLabels.length > 0) {
        this.trigger('filter:labels', this.selectedLabels);
      } else {
        this.onClearFilter();
      }
    },

    onAddLabelClick: function() {
      var self = this;
      var mailSecId = this.parentView.mailsView.mailSecId;
      
      if (!mailSecId) {
        return;
      }
      
      // Create a temporary model to use with the label popup
      var tempModel = new Backbone.Model({
        labels: this.selectedLabels.map(function(labelId) {
          return _.find(self.allLabels, function(label) {
            return label.id === labelId || label.name === labelId;
          });
        }).filter(Boolean)
      });
      
      // Add a method to the model to handle adding labels
      tempModel.addLabel = function(mailSecId, folder, label) {
        var defer = $.Deferred();
        
        // Check if the label is already selected
        var isLabelAlreadySelected = _.some(self.selectedLabels, function(selectedLabelId) {
          return selectedLabelId === label.id || selectedLabelId === label.name;
        });
        
        if (!isLabelAlreadySelected) {
          // Add the label to the selected labels
          self.selectedLabels.push(label.id || label.name);
          self.renderSelectedLabels();
          
          // Save to cookie
          self.saveSelectedLabels();
          
          // Trigger the filter event
          self.trigger('filter:labels', self.selectedLabels);
        }
        
        defer.resolve();
        return defer.promise();
      };

    Windows.open({
        view: _.bind(function () {
            return new LabelsAddView({
                mailSecId: mailSecId,
                model: tempModel
            });
        }, this),
        modal: true,
        width: 400,
        maxWidth: 800,
        title: _.i18n('mails.labels.add'),
        onClose: _.bind(function() {
            // Update the selected labels display when the popup closes
            this.renderSelectedLabels();
        }, this)
    });
    },

    onClearFilter: function() {
      this.selectedLabels = [];
      this.renderSelectedLabels();
      
      // Save to cookie
      this.saveSelectedLabels();
      
      // Trigger an event to clear the label filter
      this.trigger('filter:clear');
    }
  });
});
